import { Tenant } from '@wpp-open/core/types/tenant'

import { tenantApi } from 'api'
import { CoreApiRequestPaginationParams, CorePaginated } from 'types/api/coreApi'

export const fetchAllTenantsApi = ({ page, itemsPerPage }: CoreApiRequestPaginationParams) =>
  tenantApi.get<CorePaginated<Tenant>>('/tenants/all', { params: { page, itemsPerPage } })
